<template>
  <div class="chat-message">
    <div class="chat-message__body" v-bar>
      <div class="chat-message__wrapper" ref="list" @scroll="handlerScroll($event)">
        <transition-group :name="transitionName" tag="div" key="mess" class="chat-message__list">
          <div
            class="message"
            v-for="(message, index) in messages"
            :key="index"
            :class="{
                'message_self': message.author === 'self',
                'message_today': message.dialogDate,
              }"
          >
            <div class="message-head" v-if="message.dialogDate">
              <span>
                {{
                message.dialogDate == toDay
                ? $t("global.toDay")
                : message.dialogDate
                }}
              </span>
            </div>

            <div class="message-body">
              <div class="message-item">
                <div class="message-item__info">
                  <div class="message-item__info-left">
                    <img class="message-item__author-img" :src="userPhoto(message.author)" alt />
                    <div class="message-item__name">
                      <p>No Name</p>
                    </div>
                  </div>

                  <div class="message-item__info-right">
                    <div class="message-item__time">{{ message.datetime | filterDate }}</div>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="message-item__icon"
                    >
                      <rect x="0.756836" y="1" width="12" height="12" rx="6" stroke="#8AC135" />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10.387 4.5942C10.5647 4.41693 10.5647 4.12874 10.387 3.95147C10.2097 3.77374 9.92198 3.77374 9.74425 3.95147L4.94698 8.74874L3.44198 7.2442C3.2647 7.06647 2.97652 7.06647 2.79925 7.2442C2.62152 7.42193 2.62152 7.70965 2.79925 7.88693L4.60289 9.69102C4.61016 9.69874 4.61698 9.70647 4.6247 9.71374C4.71334 9.80283 4.8297 9.84693 4.94607 9.84693C4.96789 9.84693 4.9897 9.84556 5.01152 9.84238C5.10561 9.8292 5.19652 9.78647 5.2688 9.71374C5.27652 9.70647 5.2838 9.69874 5.29061 9.69056L10.387 4.5942Z"
                        fill="#8AC135"
                      />
                    </svg>
                  </div>
                </div>
                <transition-group
                  :name="transitionName"
                  :key="message.id"
                  class="message-item__list"
                >
                  <div class="message-item__content" v-for="(mess, i) in message.messages" :key="i">
                    <span class="message-item__text" v-if="mess.type == 'text'">{{ mess.text }}</span>
                    <div class="message-item__file-box" @click="openMedia(mess.text)" v-else>
                      <img class="message-item__file" :src="mess.text" alt @load="scrollTopList" />
                      <div class="open-file">
                        <span class="open-file__link">Open File</span>
                      </div>
                      <!-- <div>12.4mb</div> -->
                    </div>
                  </div>
                </transition-group>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>

    <div class="chat-message__controls" v-if="dialogId">
      <div class="chat-message__buttons">
        <div class="chat-message__button">
          <label>
            <input type="file" @change="addMedia" accept=".jpg, .jpeg, .png" />

            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.4009 5.56612C15.9656 5.56066 15.4605 5.73739 14.9609 6.33194C12.1943 9.62757 10.8536 11.2694 9.50853 12.9985C9.35253 13.1981 9.3438 13.3421 9.3558 13.4338C9.36998 13.5527 9.43762 13.6999 9.56962 13.8287C9.7038 13.9585 9.84998 14.0141 9.95253 14.0196C10.0267 14.0239 10.1107 14.0076 10.2154 13.8876L13.8133 9.68103C14.2114 9.20975 14.8933 9.16939 15.3362 9.59157C15.7791 10.0148 15.8173 10.7392 15.4202 11.2116L11.7896 15.4552C10.618 16.7872 9.00344 16.3814 8.11871 15.525C7.7118 15.1127 7.32016 14.3785 7.21871 13.7348C7.12489 12.981 7.32671 12.2043 7.84816 11.5356C9.20962 9.78575 10.5765 8.1123 13.3529 4.80466C14.2398 3.74866 15.3274 3.25885 16.4271 3.27303C17.4962 3.28721 18.4758 3.77485 19.2122 4.47194C20.6445 5.82794 21.4889 8.41448 19.762 10.4872C18.7594 11.6872 17.998 12.5501 17.2016 13.4501C16.0485 14.7548 14.8234 16.1403 12.694 18.7519C11.5802 20.1167 10.1827 20.7363 8.78635 20.7276C7.41616 20.7188 6.12125 20.1101 5.14162 19.1687C4.21435 18.2588 3.46053 16.8188 3.30016 15.4007C3.1518 13.8745 3.59907 12.2621 4.77835 10.8003C6.78234 8.31412 7.98234 6.82066 8.68053 5.94903C9.02962 5.51266 9.25325 5.23339 9.38962 5.06212L9.53253 4.88212L9.5718 4.83194C9.95471 4.34648 10.6343 4.28212 11.0914 4.68903C11.5474 5.09594 11.6074 5.81921 11.2245 6.30466L11.2136 6.31885L11.1809 6.3603L11.0347 6.54466C10.8973 6.71703 10.6725 6.99957 10.3223 7.43594C9.62198 8.30975 8.42089 9.80539 6.41471 12.2927C5.58889 13.317 5.36198 14.3141 5.44489 15.165C5.51471 16.1228 5.89762 16.8254 6.58598 17.4668C7.22198 18.0778 8.02053 18.429 8.79835 18.4345C9.54889 18.4388 10.3529 18.1236 11.0663 17.2487C13.2591 14.565 14.5136 13.1458 15.6569 11.853C16.4489 10.9563 17.1885 10.1196 18.1496 8.96539C18.8227 8.15703 18.6536 7.01375 17.7798 6.18575C17.3631 5.79085 16.8667 5.57266 16.4009 5.56612Z"
                fill="var(--menu-text-color)"
              />
            </svg>
          </label>
        </div>
      </div>

      <div class="chat-message__input">
        <input
          type="text"
          placeholder="Type a message here…"
          v-model.trim="messageText"
          :disabled="!dialogId"
          @keydown.enter="send"
        />
      </div>
    </div>

    <modal :show="error" @close="closeModal" :dark="true">
      <error-modal :okAction="closeModal">{{ $t("request.errorMedia") }}</error-modal>
    </modal>
    <modal :show="showModalMedia" @close="closeModal" :dark="true">
      <div class="media" @click.stop>
        <div class="media__wrapper">
          <div>
            <video :src="mediaSrc" controls="true" class="media-player" v-if="typeMedia === 'video'"></video>
            <img :src="mediaSrc" alt v-else />
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
    data() {
        return {
            messageText: '',
            sendAnimeted: false,
            currentDate: '',
            toDay: moment(new Date()).format('DD.MM.YYYY'),
            formMediaData: [],
            madiaData: '',
            error: false,
            showModalMedia: false,
            mediaSrc: '',
            typeMedia: 'image',
            scrollHeight: 0,
            messages: [],
        }
    },
    computed: {
        ...mapGetters({
            dialogId: 'dialogIdGetters',
            type: 'typeDialogsGetters',
            companionName: 'companionNameGetters',
            companionPhoto: 'companionPhotoGetters',
            adminPhoto: 'adminPhotoGetters',
            isLastMessages: 'isLastMessagesGetters',
        }),
        firstName() {
            return this.companionName.split(' ')[0]
        },
        lastName() {
            return this.companionName.split(' ')[1]
        },
        transitionName() {
            return !this.isGettingOld ? 'list' : ''
        },
        isGettingOld: {
            get() {
                return this.$store.state.chat.isGettingOld
            },
            set(data) {
                this.$store.state.chat.isGettingOld = data
            },
        },
    },
    methods: {
        send() {
            if (this.messageText) {
                this.sendAnimeted = true
                setTimeout(() => {
                    this.sendAnimeted = false
                }, 1000)
                this.sendMessageToAll(this.messageText)
                this.messageText = ''
            }
        },
        scrollTopList() {
            const { list } = this.$refs
            if (this.isGettingOld === false) {
                list.scrollTop = list.scrollHeight
            } else if (this.showModalMedia === false && list.scrollTop === 0) {
                this.lastMessageScroll()
            }
        },
        userPhoto(type) {
            return type === 'self' ? this.adminPhoto : this.companionPhoto
        },
        closeModal() {
            this.error = false
            this.showModalMedia = false
        },
        openMedia(src) {
            this.mediaSrc = src
            this.showModalMedia = true
        },
        addMedia(event) {
            const files = event.target.files[0]
            if (files.size <= 50000000) {
                // const typeFile = files.type.split('/')[0]
                const formData = new FormData()
                if (files) {
                    const reader = new FileReader()
                    reader.readAsDataURL(files)
                    reader.onload = () => {
                        this.madiaData = reader.result
                        formData.append('media', files)
                        this.formMediaData.push(formData)
                        this.sendMedia(formData, this.madiaData)
                    }
                    reader.onerror = () => {
                        // log error
                    }
                }
                formData.append('media', files)
                this.formMediaData.push(formData)
            } else {
                this.error = true
            }
        },
        openCall(id, firstName, lastName, photo, isAudioCall) {
            const user = {
                fullName: `${firstName} ${lastName}`,
                photo,
                id,
                type: this.type,
                isAnswer: false,
                isAudioCall,
            }
            this.$store.dispatch('showCallModal', user)
        },
        handlerScroll() {
            const { list } = this.$refs
            if (list.scrollTop === 0 && this.messages.length > 1) {
                this.isGettingOld = true
                this.scrollHeight = list.scrollHeight
                this.getOldMessages()
            } else if (list.scrollTop + list.clientHeight === list.scrollHeight) {
                this.isGettingOld = false
                this.$store.commit(
                    'RESET_COUNT_MESSAGE_DIALOGS',
                    this.$store.state.chat.currentDialog,
                )
            }
        },
        lastMessageScroll() {
            const { list } = this.$refs
            const currentHeight = list.scrollHeight
            list.scrollTop = currentHeight - this.scrollHeight
        },
        afterEnter() {
            // this.lastMessageScroll();
        },
        getOldMessages() {
            if (this.isLastMessages === false) {
                this.$Progress.start()
                this.$store
                    .dispatch('getOldMessages', {
                        type: this.type,
                        dialogId: this.dialogId,
                    })
                    .then(() => {
                        this.$Progress.finish()
                    })
            }
        },
        sendMessageToAll(message) {
            this.$store.dispatch('sendMessageToAll', { message })
            this.$notify({
                type: 'success',
                title: this.$t('notifications.messageSent'),
                message: this.$t('notifications.messageSentDesc'),
            })

            this.$store.dispatch('getDialogs', 'masters')
            this.messages.push({
                dialog_id: 'all',
                content: { message },
                datetime: Date.now(),
                type: 'text',
                messages: [
                    {
                        text: message,
                        type: 'text',
                    },
                ],
            })
        },
        sendMessage(message) {
            this.$store.dispatch('sendMessage', {
                type: this.type,
                dialogId: this.dialogId,
                message,
            })
        },
        sendMedia(media, media64) {
            this.$store.dispatch('sendMediaToAll', {
                type: this.type,
                dialogId: this.dialogId,
                media,
                media64,
            })

            this.messages.push({
                dialog_id: 'all',
                content: media64,
                datetime: Date.now(),
                type: 'image',
                messages: [
                    {
                        text: media64,
                        type: 'image',
                    },
                ],
            })
        },
    },
    mounted() {
    // this.scrollTopList();
    },
    updated() {
    // this.scrollTopList();
    },

    filters: {
        filterDate(time) {
            const currentTime = time
            const date = moment(currentTime).format('DD.MM.YYYY HH:mm')
            return date
        },
    },
}
</script>
<style lang="scss" scoped>
@import "src/assets/sass/main";

.chat-message__button .icon {
  color: rgb(97, 66, 45);
}
.chat-message {
  width: 80%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  margin-left: 30px;
  background-color: var(--bg-color2);
  position: relative;

  &_open {
    width: 63%;
  }
  // filter: drop-shadow(-8px 12px 18px rgba(0, 0, 0, 0.171422));
  // background-color: #ffffff;
  // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);

  overflow: hidden;
  &__body {
    flex-grow: 1;
    // background-color: #ffffff;
    height: 100%;
  }
  &__wrapper {
    height: 100%;
  }
  &__list {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 16px 0;
    min-height: 100%;
    box-sizing: border-box;
  }
  &__date {
    font-size: 20px;
    margin-bottom: 16px;
    background-color: var(--chat-hover);
    padding: 8px 0 10px 36px;
    font-size: 20px;
    line-height: 30px;
    font-family: "archivo-medium";
    color: var(--menu-text-color);
  }
  &__item {
    display: flex;
    flex-direction: column !important;
    margin-bottom: 18px;
    flex-shrink: 0;
    position: relative;
    padding-left: 36px;
    padding-right: 36px;

    &-img {
      width: 36px;
      height: 36px;
      background-position: center;
      background-size: cover;
      border-radius: 50%;
      margin-right: 16px;
      margin-left: 5px;
      flex-shrink: 0;
    }
    &-block {
      display: inline-flex;
      flex-direction: column;
      max-width: 50%;
    }
    &-time {
      font-size: 12px;
      color: #c3c3c3;
      margin-bottom: 4px;
    }
    &-list {
      display: inline-flex;
      flex-direction: column;
      align-items: flex-start;
      & .message {
        font-family: "crossten", sans-serif;

        display: inline-block;
        font-size: 15px;
        line-height: 24px;
        line-height: 1.43;
        color: #bec2cc;
        // border-radius: 24px;
        // background-color: #f3f3f3;
        // padding: 16px 23px;
        margin-bottom: 10px;

        &:first-of-type {
          border-top-left-radius: 0;
          border-top-right-radius: 24px;
          border-bottom-right-radius: 0;
          border-bottom-left-radius: 0;
        }
        &:last-of-type {
          // border-top-right-radius: 0;
          border-top-left-radius: 0;
          border-bottom-right-radius: 24px;
          border-bottom-left-radius: 24px;
        }
        & img {
          max-width: 320px;
          max-height: 200px;
          object-fit: cover;
        }
      }
    }
    &--self {
      flex-direction: row-reverse;
      & .chat-message__item-img {
        margin-right: 0;
        margin-left: 16px;
      }
      & .chat-message__item-block {
        align-items: flex-end;
      }
      & .message {
        // background-color: #fcee21;
        &:first-of-type {
          border-top-right-radius: 0;
          border-top-left-radius: 24px;
          border-bottom-right-radius: 0;
          border-bottom-left-radius: 0;
        }
        &:last-of-type {
          border-top-right-radius: 0;
          border-bottom-right-radius: 24px;
          border-bottom-left-radius: 24px;
        }
      }
      & .chat-message__item-list {
        align-items: flex-end;
      }
    }
    // &--date {
    //   padding-top: 36px;
    // }
  }
  &__controls {
    flex-shrink: 0;
    // height: 64px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    background-color: var(--chat-hover);
    // box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.16);
    display: flex;
    padding-left: 24px;
    padding-right: 20px;
    justify-content: space-around;
    align-items: center;
    z-index: 1;
    padding: 5px 52px;
  }
  &__buttons {
    display: flex;
    align-items: center;
  }
  &__button {
    margin-right: 16px;
    cursor: pointer;

    & .icon {
      width: 30px;
      height: 30px;
      transition: 0.5s;
      &:hover {
        transform: scale(1.2);
      }
    }
    & input {
      display: none;
    }
  }
  &__input {
    flex-grow: 1;
    padding-right: 20px;
    & input {
      font-size: 14px;
      width: 100%;
      height: 44px;
      border-radius: 8px;
      background-color: transparent;
      border: solid 1px transparent;
      outline: none;
      color: var(--menu-text-color);
    }
  }
  &__send {
    position: relative;
    & .icon {
      width: 30px;
      height: 30px;
    }
    &.animeted {
      &::before {
        content: "";
        position: absolute;
        left: -17px;
        top: -14px;
        width: 55px;
        height: 55px;
        display: inline-block;
        border-radius: 50%;
        opacity: 0.4;
        background-color: $primaryColor;
        transform: scale(0);
        animation: sendAnim 1s infinite;
      }
    }
    & .counter-media {
      position: absolute;
      width: 15px;
      height: 15px;
      background-color: #fcee20;
      border-radius: 50%;
      text-align: center;
      line-height: 1.3;
      color: #000;
      right: 0;
      top: 20px;
      border: 1px solid #70bd4a;
    }
  }
}
@keyframes sendAnim {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1);
    opacity: 0.4;
  }
  100% {
    transform: scale(0);
    opacity: 0;
  }
}
.media {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 16px 24px 0 rgba(0, 0, 0, 0.24);
  padding: 44px;
  max-width: 1130px;
  box-sizing: border-box;
  &__wrapper {
    & div {
      max-height: 80vh;
    }
    & video {
      width: 100%;
      height: auto;
    }
    & img {
      width: 100%;
      height: auto;
    }
  }
}
.no-move-list-leave-active.list-item {
  transition: none !important;
}

.message {
  width: 100%;
  margin-bottom: 16px;

  &-head {
    font-size: 20px;
    margin-bottom: 17px;
    background-color: var(--chat-hover);
    padding: 8px 0 10px 36px;
    font-size: 20px;
    line-height: 30px;
    font-family: "archivo-medium";
    color: var(--menu-text-color);
  }

  &-body {
    width: max-content;
    padding-left: 36px;
    padding-right: 36px;
    // border: 2px solid red;
  }

  &-item {
    display: flex;
    flex-direction: column;

    &__info {
      width: 100%;
      max-width: 90%;
      max-width: max-content;

      display: flex;
      align-items: center;
      justify-content: space-between;

      &-left {
        display: flex;
        align-items: center;
        order: 1;
      }

      &-right {
        display: flex;
        align-items: center;
        order: 2;
      }
    }

    &__list {
      padding-left: 48px;
      color: #bec2cc;
    }

    &__author-img {
      border-radius: 50%;
      width: 36px;
      height: 36px;
      order: 1;
      margin-right: 12px;
      display: inline-block;
    }

    &__name {
      color: var(--menu-text-color);
      order: 2;
      width: 223px;
      font-weight: 600;
      font-size: 15px;
      line-height: 19px;
    }

    &__time {
      color: var(--label-color);
      font-family: "lexend_deca", sans-serif;
      order: 1;
      margin-right: 8px;
    }

    &__icon {
      order: 2;
    }

    &__text {
      font-size: 15px;
      color: #bec2cc;
      font-family: "lexend_deca", sans-serif;
      display: block;
      margin-bottom: 8px;
    }

    &__file-box {
      background-color: var(--bg-color);
      padding: 16px;
      width: 100%;
      max-width: 300px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      cursor: pointer;

      img {
        width: 56px;
        height: 56px;
        border-radius: 8px;
      }

      .open-file {
        height: 100%;
        margin-left: 12px;
        padding: 5px 0;

        &__link {
          font-weight: 600;
          font-size: 15px;
          color: var(--menu-text-color);
        }
      }
    }
  }

  &_self {
    .message-body {
      margin-left: auto;
    }
    .message-item {
      &__info {
        &-left {
          order: 2;
        }

        &-right {
          order: 1;
        }
      }

      &__author-img {
        order: 2;
        margin-left: 12px;
        margin-right: unset;
      }

      &__name {
        color: var(--menu-text-color);
        order: 1;
        text-align: right;
      }

      &__time {
        order: 2;
        margin-right: unset;
        margin-left: 8px;
      }

      &__icon {
        order: 1;
      }

      &__list {
        padding-left: unset;
        padding-right: 48px;
        text-align: right;
      }

      &__file-box {
        margin-left: auto;
      }
    }
  }
}
</style>
